<template>
<div class="updataUser-container">
   <div class="head">
    <p>修改用户信息</p>
   </div>
  <div class="form-container">
    <el-form :model="form"  label-width="100px" class="user-form" ref="userForm">
      <el-form-item label="头像" prop="avatar">
        <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                   :http-request="UploadFile"
                  >
                  <div class="avatar-container">
                    <img :src="form.avatar || Avatar" class="avatar">
                    <!-- <img src="https://sxdatasets.oss-cn-chengdu.aliyuncs.com/2/dataset/Snipaste_2025-06-19_17-36-51.png" class="avatar"> -->
                    <div class="avatar-overlay">
                      <img :src="camera" class="camera-icon">
                    </div>
                  </div>
                </el-upload>
      </el-form-item>
            <el-form-item label="姓名" prop="name" required>
              <el-input 
                v-model="form.name" 
                placeholder="请输入您的姓名"
                maxlength="30"
                show-word-limit
                class="form-input">
              </el-input>
            </el-form-item>

            <el-form-item label="公司名称" prop="company" required>
              <el-input 
                v-model="form.company" 
                placeholder="请输入公司名称"
                maxlength="50"
                show-word-limit
                class="form-input">
              </el-input>
            </el-form-item>

            <el-form-item label="邮箱" prop="email">
              <el-input 
                v-model="form.email" 
                placeholder="请输入邮箱地址"
                class="form-input">
              </el-input>
            </el-form-item>

            <el-form-item label="官网" prop="website">
              <el-input 
                v-model="form.website" 
                placeholder="请输入官网地址"
                class="form-input">
              </el-input>
            </el-form-item>

            <el-form-item label="简介" prop="description">
              <el-input 
                type="textarea"
                v-model="form.description" 
                placeholder="请输入简介"
                :rows="6"
                resize="none"
                maxlength="100"
                show-word-limit
                class="form-textarea">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm">提交</el-button>
              <el-button  @click="cancelForm">取消</el-button>
            </el-form-item>
          </el-form>
  </div>
</div>
</template>

<script>

import {SetUserInfo} from '@/api/user'
import Avatar from "@/assets1/后台/Avatar.png";
import {Message} from 'element-ui'
import camera from "@/assets1/后台/camera.png";
import {FileUpLoad } from '@/server/UpLoadFile'
export default {
data(){
    return{imageUrl:'',text:'', form: {
        avatar: this.$store.state.userInfo.avatar_url,
        name: this.$store.state.userInfo.username,
        company: this.$store.state.userInfo.company_name,
        email: this.$store.state.userInfo.email,
        website: this.$store.state.userInfo.website,
        description: this.$store.state.userInfo.bio
      },
      avatarUrl:'',
      camera,Avatar}
},
methods:{
  async UploadFile(options){
    console.log(options,'file');
    const res=await FileUpLoad(options.file)
    console.log(res,'res');
    this.form.avatar=res
    this.avatarUrl='https://sxdatasets.oss-cn-chengdu.aliyuncs.com/'+res
  },
 async submitForm(){
   const res=await SetUserInfo({
    username:this.form.name,
    company_name:this.form.company,
    avatar_bucket:'sxdatasets',
    avatar_object:this.form.avatar,
    email:this.form.email,
    website:this.form.website,
    bio:this.form.description
   })
   this.$store.commit('setUserInfo',{
    avatar_url:this.form.avatar,
    username:this.form.name,
    company_name:this.form.company,
    email:this.form.email,
    website:this.form.website,
    bio:this.form.description
   })
   Message({
    message: '修改成功',
    type: 'success'
  });
  console.log(res,'2222');
  
  this.avatarUrl=''
  this.cancelForm()
   console.log(res,'res');
  },
  cancelForm(){
    this.$refs.userForm.resetFields()
  }
}
}
</script>

<style scoped>
.avatar-item {
  width: 80px;
  height: 80px;
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.avatar-container {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
  object-fit: cover;
  border-radius: 50%;
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(34, 34, 34, 0.40);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.avatar-container:hover .avatar-overlay {
  opacity: 1;
}

.camera-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}


.user-form {
  margin-bottom: 40px;
}

.form-input {
  width: 100%;
}

.form-textarea {
  width: 570px;
}
.el-upload__tip{
    font-size: 12px;
    color: #999;
}
.sucess{
    background-color: #0D53FF;
    color: white;
  
}
.del{
    background-color: #fff;
    color: #666666;
    
}
.btnList button{
    width: 80px;
    height: 32px;
       border: 1px solid #E9E9E9;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 4px;
}
::v-deep .el-input{
    width: 570px;
    height: 36px;
}
.iconbox{
width: 100%;
height: 100%;
   display: flex;
   flex-direction: column;
   justify-content: center;
   color: #E0E0E0;
 
}
.iconbox p{
    margin-top: 12px;
    font-size: 12px;
    line-height: 17px;
    height: 17px;
}
.el-icon-plus{
    font-size: 20px;
    
 
}
::v-deep .el-upload{
    width: 100px;height: 100px;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
          
}

.updataUser-container{
    margin-top: 24px;
    margin-left: 24px;
     font-family: Regular;
}
.head{
    font-size: 24px;
    font-family: Medium;
    margin-bottom: 27px;

}
</style>